module.exports = __webpack_public_path__ + "static/pic11-3b9807f4e444feb3e84fd8c0665c57c7.jpg";